import { styled, Radio } from "@mui/material";
const RadioStyled = styled(Radio)(({ theme }) => ({
  padding: "0",
  marginRight: "12px",
  color: theme.palette.secondary[900],
  height: "16px",
  position: "relative",
  "&.Mui-checked": {
    color: theme.palette.secondary[900]
  },
  "&:hover": {
    backgroundColor: theme.palette.secondary[200],
    color: theme.palette.secondary[800],
    "&.Mui-checked": {
      color: theme.palette.secondary[800],
      backgroundColor: theme.palette.white.main
    }
  },
  "&:active": {
    backgroundColor: theme.palette.secondary[200],
    color: theme.palette.secondary[1e3],
    "&.Mui-checked": {
      color: theme.palette.secondary[1e3],
      backgroundColor: theme.palette.white.main
    }
  },
  "&.Mui-disabled": {
    color: theme.palette.grey[400]
  },
  "&.MuiRadio-colorError": {
    color: theme.palette.error.main,
    "&:hover": {
      color: theme.palette.error.main,
      "&.Mui-checked": {
        color: theme.palette.error.main
      }
    }
  }
})), RadioContainerStyled = styled("div")({
  display: "flex",
  flexDirection: "column"
});
export {
  RadioContainerStyled,
  RadioStyled
};
//# sourceMappingURL=styles.js.map
